<template>
    <div class="d-lg-flex align-items-center justify-content-end">
        <b-navbar-nav class="pl-lg-4">
            <router-link tag="li" :to="$i18nRoute({name:'home'})" class="nav-item" :class="{'menu-is-active': isSub(['race'])}">
                <a class="nav-link px-3">{{$t('header.events')}}</a>
            </router-link>
            <!--
            <router-link tag="li" :to="$i18nRoute({ name: 'circuiti'})" class="nav-item">
                <a class="nav-link px-3">{{$t('header.paths')}}</a>
            </router-link>
            -->
            <router-link tag="li" :to="$i18nRoute({ name: 'servizi'})" class="nav-item">
                <a class="nav-link px-3">{{$t('header.services')}}</a>
            </router-link>
            <router-link tag="li" :to="$i18nRoute({ name: 'chi-siamo'})" class="nav-item">
                <a class="nav-link px-3">{{$t('header.about')}}</a>
            </router-link>
           <!-- <router-link tag="li" :to="$i18nRoute({ name: 'contatti'})" class="nav-item">
                <a class="nav-link px-3">{{$t('header.contacts')}}</a>
            </router-link>-->
            <router-link tag="li" :to="$i18nRoute({ name: 'lavora-con-noi'})" class="nav-item d-block d-lg-none"  v-if="currentLanguage === 'IT'">
                <a class="nav-link px-3">{{$t('header.jobs')}}</a>
            </router-link>
        </b-navbar-nav>
        <div class="language-switcher-wrapper">
            <LanguageSwitcher/>
        </div>
    </div>
</template>

<script>
    import LanguageSwitcher from './LanguageSwitcher'
    import { Trans } from '@/plugins/Translation'
    export default {
        name: "MenuHead",
        components: {
            LanguageSwitcher
        },methods: {
            isSub(input) {
                let path = this.$route.name
                for (let i = 0; i < input.length; i++)
                    if (path === input[i])
                        return true
                return  false
            }
        },computed: {
            currentLanguage () {
                return Trans.currentLanguage
            }
        },
    }
</script>

<style scoped>

</style>
